import {
    GET_DISTRIBUTOR_LIST,
    UPDATE_DISTRIBUTOR,
    UPDATE_DISTRIBUTORS,
    ADD_DISTRIBUTOR,
} from './distributors.actionTypes';

import {
    DISTRIBUTOR_STATUSES
} from '../../config/constants';

const updateDistributor = (state, updatedDistributor) => {
    return state.filter((distributor) => {
        if (distributor._id === updatedDistributor.id) {
            if (updatedDistributor.hasOwnProperty('status')) {
                distributor.status = updatedDistributor.status;
            }
            if (updatedDistributor.hasOwnProperty('location') &&
                updatedDistributor.location.lat && updatedDistributor.location.lng) {
                distributor.location = updatedDistributor.location;
            }
            if (updatedDistributor.hasOwnProperty('orderCount')) {
                distributor.orderCount = updatedDistributor.orderCount;
            }

            if (updatedDistributor.hasOwnProperty('locked')) {
                distributor.locked = updatedDistributor.locked;
            }

            if (updatedDistributor.hasOwnProperty('isDeactive')) {
                distributor.isDeactive = updatedDistributor.isDeactive;
            }

            if (updatedDistributor.hasOwnProperty('distributorDebt')) {
                distributor.distributorDebt = updatedDistributor.distributorDebt;
            }
            if (updatedDistributor.hasOwnProperty('payableAmount')) {
                distributor.payableAmount = updatedDistributor.payableAmount;
            }

            if (updatedDistributor.hasOwnProperty('rest')) {
                distributor.rest = updatedDistributor.rest;
            }
            if (updatedDistributor.hasOwnProperty('distributorCooperationType')) {
                distributor.distributorCooperationType = Number(updatedDistributor.distributorCooperationType);
            }
            if (updatedDistributor.hasOwnProperty('posTerminalId')) {
                distributor.posTerminalId = Number(updatedDistributor.posTerminalId);
            }
            if (updatedDistributor.hasOwnProperty('sanitaryBookStatus')) {
                distributor.sanitaryBookStatus = updatedDistributor.sanitaryBookStatus;
            }
        }
        return distributor;
    });
};

export default function distributors(state = [], action) {
    let newState = Object.assign([], state);
    switch (action.type) {
        case GET_DISTRIBUTOR_LIST:
            const distributors = action.distributors || action.allDistributors || [];
            // Check if data is nested in a .data property
            const distributorArray = distributors?.data || distributors;
            // Ensure we have an array before mapping
            if (!Array.isArray(distributorArray)) {
                return state;
            }
            return distributorArray.map((distributor) => {
                distributor.status = DISTRIBUTOR_STATUSES.IS_OFFLINE.statusId;
                return distributor;
            });
        case UPDATE_DISTRIBUTOR:
            return updateDistributor(newState, action.distributor);
        case UPDATE_DISTRIBUTORS:
            action.distributors.map((distributor) => {
                updateDistributor(newState, distributor);
                return distributor;
            });
            return newState;
        case ADD_DISTRIBUTOR:
            return [...newState, action.distributor];
        default:
            return newState;
    }
}
